/** Amber, role="status" so screen readers announce it without stealing focus. */
export function DraftBanner() {
  return (
    <div className="draft-banner" role="status">
      Draft content, pending Astute review. Not for operational use.
    </div>
  )
}
